module.exports = __webpack_public_path__ + "static/voyayge-hrt-mobile-850225707040dcd61b259c1682333720.png";